import {
  IColumnFilterMDS,
  IColumnGroupColumn,
  IDimensionColumn,
  IProjection,
  IReportCoaDimensionMetadata,
  IReportConfiguration,
  IReportDimension,
  ISingleValueColumnFilter
} from '@opengov/reporting-types';

export enum ReportConfigurationStatus {
  Loading = 'loading',
  Updating = 'updating',
  Current = 'current'
}

export interface ISetColumnGroupFilters {
  (oldState: IReportConfiguration, payload: ISetColumnGroupFiltersPayload): IReportConfiguration;
}

export interface ISetRowGroupFilters {
  (oldState: IReportConfiguration, payload: ISetColumnRowFiltersPayload): IReportConfiguration;
}

export interface ISetColumnGroupFiltersPayload {
  columnGroupIndex: number;
  filters: IColumnFilterMDS<IProjection>[];
  dateFilters: ISingleValueColumnFilter<IColumnGroupColumn>[];
}

export interface ISetColumnRowFiltersPayload {
  columnRowIndex: number;
  filters: IColumnFilterMDS<IDimensionColumn>[];
}
export interface ISetAccountSummarySelectedColumnPayload {
  coaDimensionMetadata: IReportCoaDimensionMetadata;
  dateDimension: IReportDimension;
  openColumnIndex: number;
  selectedColumn: string[];
}
